"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");
/**
 * InputHelper
 * UI element which provides helper and/or error text. You can find this element below an InputGroup (if you provide an errorText and/ or a helperText).
 * If you provide both, only the errorText is shown.
 */


var InputHelper = function InputHelper(_a) {
  var id = _a.id,
      className = _a.className,
      helperText = _a.helperText,
      errorText = _a.errorText;
  return React.createElement("div", {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "input-helper", errorText && CSSPrefix_1.lsgPre + "input-helper__error", className]),
    role: errorText ? "alert" : undefined,
    "aria-atomic": true
  }, errorText || helperText);
};

exports.InputHelper = InputHelper;
InputHelper.displayName = "InputHelper";